/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalDoctorsStatus =
    (typeof GetApiDoctorsPortalDoctorsStatus)[keyof typeof GetApiDoctorsPortalDoctorsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalDoctorsStatus = {
    INVITED: 'INVITED',
    LINKED: 'LINKED',
    REJECTED: 'REJECTED',
    SELF_UNLINKED: 'SELF_UNLINKED',
    REMOVED: 'REMOVED',
} as const;
